import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_AI_CONVERSATION_MONITOR_STATE,
});

export const syncLiveAiConversations = () => ({
  type: types.SYNC_LIVE_AI_CONVERSATIONS.REQUEST,
});

export const syncLiveAiConversationsSuccess = (conversations) => ({
  type: types.SYNC_LIVE_AI_CONVERSATIONS.SUCCESS,
  conversations,
});

export const syncLiveAiConversationsFailure = (error) => ({
  type: types.SYNC_LIVE_AI_CONVERSATIONS.FAILURE,
  error,
});

export const syncTodayAiConversations = () => ({
  type: types.SYNC_TODAY_AI_CONVERSATIONS.REQUEST,
});

export const syncTodayAiConversationsSuccess = (conversations) => ({
  type: types.SYNC_TODAY_AI_CONVERSATIONS.SUCCESS,
  conversations,
});

export const syncTodayAiConversationsFailure = (error) => ({
  type: types.SYNC_TODAY_AI_CONVERSATIONS.FAILURE,
  error,
});

export const fetchMonitorLeads = (leadIds) => ({
  type: types.FETCH_MONITOR_LEADS.REQUEST,
  leadIds,
});

export const fetchMonitorLeadsSuccess = (leads) => ({
  type: types.FETCH_MONITOR_LEADS.SUCCESS,
  leads,
});

export const fetchMonitorLeadsFailure = (error) => ({
  type: types.FETCH_MONITOR_LEADS.FAILURE,
  error,
});

export const takeBackAiConversations = (conversationIds) => ({
  type: types.TAKE_BACK_AI_CONVERSATIONS.REQUEST,
  conversationIds,
});

export const takeBackAiConversationsSuccess = (result) => ({
  type: types.TAKE_BACK_AI_CONVERSATIONS.SUCCESS,
  result,
});

export const takeBackAiConversationsFailure = (error) => ({
  type: types.TAKE_BACK_AI_CONVERSATIONS.FAILURE,
  error,
});

export const stopAllAiConversations = (agentId = '') => ({
  type: types.STOP_ALL_AI_CONVERSATIONS.REQUEST,
  agentId,
});

export const stopAllAiConversationsSuccess = (result) => ({
  type: types.STOP_ALL_AI_CONVERSATIONS.SUCCESS,
  result,
});

export const stopAllAiConversationsFailure = (error) => ({
  type: types.STOP_ALL_AI_CONVERSATIONS.FAILURE,
  error,
});
